(function() {
  'use strict';

  angular.module('ringbaPortal.services').factory('changelogService', changelogService);

  function changelogService(
    _,
    $http,
    $q,
    cacheService,
    moment,
    ngAuthSettings
  ) {
    'ngInject';

    const limit = 20;

    const service = {
      getAccountChangelog: getAccountChangelog,
      getAccountChangelogByObject: getAccountChangelogByObject,
      getAccountChangelogByUsername: getAccountChangelogByUsername,
      getChangelogRequestLimit: getChangelogRequestLimit
    };
    return service;

    function getAccountChangelog(accountId, data) {
      const url = _serviceUserBaseUrl(accountId);
      return _handleChangelogApiRequest(url, data);
    }

    function getAccountChangelogByObject(accountId, objectId, data) {
      const url = _serviceUserBaseUrl(accountId) + '/object/' + objectId;
      return _handleChangelogApiRequest(url, data);
    }

    function getAccountChangelogByUsername(accountId, data) {
      const url = _serviceUserBaseUrl(accountId) + '/user';
      return _handleChangelogApiRequest(url, data);
    }

    function getChangelogRequestLimit() {
      return limit;
    }

    function _handleChangelogApiRequest(url, data) {
      const cacheKey = _getCacheKey(url, data);

      if (cacheService.get(cacheKey)) {
        return $q.when(cacheService.get(cacheKey));
      }

      return $http.post(url, data).then(function (response) {
        return _handleChangelogResponse(response, cacheKey);
      });
    }

    function _handleChangelogResponse(response, cacheKey) {
      const logs = response.data.changeLog && angular.copy(response.data.changeLog.changeLog);
      
      if (logs) {
        _.remove(logs, function (log) {
          return log.action === 'Update' && !log.diff;
        });
      }

      const returnData = {
        logs: logs || [],
        checkMoreLogs: response.data.changeLog && response.data.changeLog.changeLog.length >= limit,
        endDateForNextRequest: (logs && logs.length && moment(logs[logs.length - 1].dtStamp)) || null 
      };

      if (cacheKey) {
        cacheService.set(cacheKey, returnData, {
          expireAfterSeconds: 60,
          persistence: false
        });
      }

      return returnData;
    }

    function _getCacheKey(url, data) {
      return url + '-firstRequest=' + (data.end ? data.end : 'start') + (data.userName ? '-user=' + data.userName : '');
    }

    function _serviceUserBaseUrl(accountId) {
      return ngAuthSettings.apiServiceBaseUri + accountId + '/changelog';
    }

  }
})();
